import { List, P, Strong } from '@ahmdigital/ui';

import { ambulanceIntro, dependantsExcess, StyledSmall } from './shared';

const accidentOverrideIntro = {
  definitionDisclaimer: (
    <P>
      <StyledSmall>#</StyledSmall>We will pay benefits towards the initial and ongoing hospital treatment that resulted
      from an Accident for all services that are listed as excluded and restricted on your cover. An Accident refers to
      an unplanned or unforeseen event resulting in bodily injury that requires immediate medical treatment in a
      hospital.
    </P>
  ),
  excess: (
    <>
      <Strong>No excess for Accidents</Strong> under Accident Override^^
    </>
  ),
  excessDisclaimer: (
    <P>
      ^^If you are admitted to hospital for an Accident, where possible we’ll waive the excess upfront. However, due to
      the way we receive claims for hospitalisations relating to Accidents, the hospital may require you to pay the
      excess on the day of the admission. We’ll then reimburse this amount, subject to eligibility of the waiver. The
      excess will only be waived for the first admission each membership year in relation to a non-compensatable
      Accident.
    </P>
  ),
};

export const featuresWithAccidentOverride = {
  disclaimers: (
    <>
      {accidentOverrideIntro.definitionDisclaimer}
      {accidentOverrideIntro.excessDisclaimer}
      {ambulanceIntro.featureDisclaimer}
    </>
  ),
  features: (
    <>
      <Strong>Features</Strong>
      <List variant={['inside', 'withBottomMargin']}>
        <li>{accidentOverrideIntro.excess}</li>
        <li>{dependantsExcess}</li>
        <li>{ambulanceIntro.feature}</li>
      </List>
    </>
  ),
};
